const faqDataAU = [
    {
        id: 0,
        category: 'General',
        question: 'How do I contact LifeSafer?',
        answer: 'Our Help section provides you with 2 options to get in touch with us either by email or phone. ',
        internalLink: '/help',
        linkText:'Click here and get started.'
    },
    {
        id: 1,
        category: 'General',
        question: 'How do I update my ID information?',
        answer: 'Your ID information can be accessed by clicking on the Profile Icon in the top right corner of the site and navigating to the State Information tab of your Profile. Then, click the arrow next to the State ID information to edit. ',
        internalLink: '/profile',
        linkText: 'Click here to go there now.'
    },
    {
        id: 2,
        category: 'General',
        question: 'How can I update my password?',
        answer: 'You can update your Password by clicking on the Profile Icon in the top right corner of the site and then click the arrow next to the Password to update. ',
        internalLink: '/profile',
        linkText: ' Click here to update now.'
    },
    {
        id: 3,
        category: 'General',
        question: 'How can I update my address?',
        answer: 'Your Address can be accessed by clicking on the Profile Icon in the top right corner of the site and navigating to the State Information tab of your Profile. Then, click the arrow next to the Address to edit. ',
        internalLink: '/profile',
        linkText: 'Click here to go there now.'
    },
    {
        id: 4,
        category: 'General',
        question: 'I need service done on my vehicle. What do I need to do to keep in compliance?',
        answer: 'It’s important that LifeSafer knows about service being done to your vehicle so that we make sure your mechanic is not only ready to perform the service but keeps you in compliance. ',
        externalLink: 'https://www.lifesafer.au/mechanic-states/',
        linkText:'Click here to get the Mechanic Affidavit Form for your state.'
    },
    {
        id: 5,
        category: 'Device',
        question: 'Where do I find my Device Information?',
        answer: 'Our Dashboard page contains your Device Information, click the Menu Icon in the top right corner of the tile and you will see a link to your device’s User Guide.',
        internalLink: '/ ',
        linkText: 'Click here to go to your Dashboard.'
    },
    {
        id: 6,
        category: 'Device',
        question: 'My device is locked out. What do I need to do?',
        answer: 'We can help you with your lock out. Our Help section provides you with 2 options to get in touch with us either by email or phone. ',
        internalLink: '/help',
        linkText: 'Click here and get started.'
    },
    {
        id: 7,
        category: 'Appointments',
        question: 'How do I schedule, reschedule, or cancel a Monitoring or Installation Appointment?',
        answer: 'Monitoring and Installation appointments can be handled in the Appointment section of the portal. ',
        internalLink: '/appointments',
        linkText: 'Click here to update your Monitoring or Installation appointment now.'
    },
    {
        id: 8,
        category: 'Appointments',
        question: 'Where do I get information about Deinstallation?',
        answer: 'Region specific rules surrounding deinstallation is something our expert support team can guide you through so we can help you complete your program successfully. Our Help section provides you with 2 options to get in touch with us either by email or phone. ',
        internalLink: '/help',
        linkText: 'Click here and get started.'
    },
]

export default faqDataAU